export default __webpack_public_path__ + "dd573e3e6884151162ab95e0e033ba42.jpeg";